/**
 * Due to an intermittent `google.visualization.DataTable is not a constructor` error,
 * (which mainly shows up when using Hot-Reload whilst developing),
 * we check if it is construtable (i.e. loaded) before doing anything
 *
 * https://stackoverflow.com/a/70810697
 */
export const getDataTable = ({ rows }) => {
    if (!google.visualization.DataTable ||
        typeof google.visualization.DataTable !== 'function' ||
        !google.visualization.DataTable.prototype ||
        !google.visualization.DataTable.prototype.constructor)
        return null;
    const dataTable = new google.visualization.DataTable();
    dataTable.addColumn({ type: 'string', id: 'Operation' });
    dataTable.addColumn({ type: 'string', id: '_name' });
    dataTable.addColumn({ type: 'string', id: 'style', role: 'style' });
    dataTable.addColumn({ type: 'date', id: 'Start' });
    dataTable.addColumn({ type: 'date', id: 'End' });
    dataTable.addRows(rows);
    return dataTable;
};
